<template>
  <div>
    <ActionsWrapper>
      <template v-if="isComposing" #composeActions>
        <v-textarea
          v-model="localValue"
          name="textField"
          :label="$t('message.reviews.yourAnswer')"
          v-validate="
            isNested
              ? 'required'
              : 'required|max-length:200|min-length:10|min-words:3'
          "
          :error-messages="errors.collect('textField')"
          autofocus
          rows="3"
        ></v-textarea>
        <ComposeActions @cancel="handleCancel" @publish="handleUpdate" />
      </template>
      <template v-else #publishActions>
        <OwnerActions
          @toggle-edit-mode="handleToggleEditMode"
          @delete="showDeleteDialog = true"
        />
      </template>
    </ActionsWrapper>
    <DeleteAlertDialog
      v-if="showDeleteDialog"
      @close="showDeleteDialog = false"
      @confirm="handleDelete"
    />
  </div>
</template>

<script>
import OwnerActions from "@/components/QuestionsAndAnswers/QaListItemOwnerActions.vue";
import ComposeActions from "@/components/QuestionsAndAnswers/QaListItemComposeActions.vue";
import ActionsWrapper from "@/components/QuestionsAndAnswers/QaListItemActionsWrapper.vue";

export default {
  name: "QaListItemEditActions",
  components: {
    OwnerActions,
    ComposeActions,
    ActionsWrapper,
    DeleteAlertDialog: () =>
      import("@/components/QuestionsAndAnswers/QaListItemDeleteAlertDialog.vue")
  },
  props: {
    value: {
      type: String,
      required: true
    },
    isNested: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: "",
      showDeleteDialog: false,
      isComposing: false
    };
  },

  created() {
    this.localValue = this.value;
  },
  methods: {
    handleCancel() {
      this.isComposing = false;
      this.localValue = this.value;
      this.$emit("cancel");
    },
    handleUpdate() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("update", this.localValue);
          this.isComposing = false;
        }
      });
    },
    handleToggleEditMode() {
      this.isComposing = true;
      this.$emit("toggle-edit-mode");
    },
    handleDelete() {
      this.$emit("delete");
      this.showDeleteDialog = false;
    }
  }
};
</script>
